var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fusioncharts',{attrs:{"set":_vm.dataSource.pointers.pointer[0].value=_vm.dvalue,"type":_vm.type,"width":_vm.width,"height":_vm.height,"dataFormat":_vm.dataFormat,"dataSource":_vm.dataSource}})
}
var staticRenderFns = []

export { render, staticRenderFns }